// extracted by mini-css-extract-plugin
export default {"back_wrap":"Backbutton_back_wrap__mKu9K","back_btn":"Backbutton_back_btn__o6iln","donate_btn":"Backbutton_donate_btn__j3aMh"};